import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INotification } from '../models/notification2.model';

interface INotificationState {
  notifications: INotification[];
}

const initialState: INotificationState = {
  notifications: [],
};

const notificationSlicer = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification: (state: any, action: PayloadAction<INotification>) => {
      state.notifications = [...state.notifications, action.payload];
    },
  },
});

export const { addNotification } = notificationSlicer.actions;

export default notificationSlicer.reducer;
